import React, {useEffect, useState, useCallback, useMemo} from 'react'
import {Node, useReactFlow} from 'reactflow'
import {useSelector, useDispatch} from 'react-redux'
import {KTSVG, toAbsoluteUrl} from '../../../../../../../_metronic/helpers'
import {findMatchingArrayName, removeOptOutOrReply} from '../../../../../../Utils/_helpers'
import {GLOBAL_SETTINGS_TYPE} from '../../../../../../Utils/Constant/ConstantForWebsite'
import {
  getAllUserDetails,
  getIsDefaultRegion,
} from '../../../../accounts/Overview/OverviewSlice/UserDetailsSlice'
import moment from 'moment-timezone'
import Select, {components, MenuListProps} from 'react-select'
import {getBusinessName} from '../../../../accounts/BusinessName/BusinessNameSlice/BusinessSlice'
import {getCustomNunberList} from '../../../../accounts/CustomNumber/CustomNumberSlice/CustomNumberSlice'
import {getDedicatedNumber} from '../../../../accounts/DedicatedNumber/DedicatedNumberSlice/DedicatedNumberSlice'
import {getDefaultRegion} from '../../../../accounts/Overview/OverviewSlice/UserDetailsSlice'
import {REGION} from '../../../../../../Utils/Constant/ConstantForWebsite'
import {toUpper} from 'lodash'
import clsx from 'clsx'
import {OverlayTrigger, Tooltip, Modal} from 'react-bootstrap'
import CreateBusinessNamePopup from '../../../../accounts/BusinessName/Modal/CreateBusinessNamePopup'
import VirtualNumbersModal from '../../../../accounts/DedicatedNumber/VirtualNumbersModal'
import CreateCutomNumber from '../../../../accounts/CustomNumber/Modal/CreateCutomNumber'
import {Elements} from '@stripe/react-stripe-js'
import './SMSSidebar.scss'
import StripeJSProvider from '../../../../../../Utils/StripeJSProvider'
import {DataNode, MetaDataWithSMS} from '../../FlowTypes'
import {useSenderId} from '../hooks/useSenderId'
import {useI18n} from '../../../../../../Utils/_helpers/useI18n'
import {
  getAllTemplateWithoutPagination,
  getTemplateListWithoutPagination,
} from '../../../../MyTemplate/CreateScratch/CreateScratchSlices/CreateScratchSlices'
import {confirm} from 'react-confirm-box'
import CreateScratchV2 from '../../../../MyTemplate/CreateScratch/CreateScratchV2'
import {TemplateMessage} from '../../../../MyTemplate/CreateScratch/Template'

type ReactSelectOption = {
  value: string
  label: string
}

const SMSSidebar: React.FC<{node: Node<DataNode<MetaDataWithSMS>>}> = ({node}) => {
  const {setNodes} = useReactFlow()
  const dispatch = useDispatch()
  const {t} = useI18n()

  // Template selection state
  const [selectedTemplate, setSelectedTemplate] = useState<TemplateMessage | null>(null)
  const [showTemplateModal, setShowTemplateModal] = useState(false)
  const [isSelectOpen, setIsSelectOpen] = useState(false)
  const [isUpdatingTemplate, setIsUpdatingTemplate] = useState(false)
  const [isEdit, setIsEdit] = useState(false)

  // Template data
  const templates: TemplateMessage[] = useSelector(getTemplateListWithoutPagination)

  const [sendData, setSendData] = useState({
    message: node?.data?.metaData?.sms?.message || '',
    optout: true,
    replyStopToOptOut: true,
    sender: node?.data?.metaData?.sender || 'Sender ID',
    senderType: node?.data?.metaData?.senderType || '',
    optoutId: '',
  })

  const {
    selectedSender,
    setSelectedSender,
    selectedSenderType,
    setSelectedSenderType,
    isDefaultRegion,
    userRegion,
    isShowCredit,
    dedicatedOptionMMS,
    dedicatedOptionSMS,
    businessNameOption,
    customNumberOption,
    senderTypeData,
    handleSenderChange,
    OptOutDefault,
    optoutList,
    visible,
    setVisible,
    name,
    setName,
    customNumber,
    setCustomNumber,
    isAdmin,
    alphaID,
  } = useSenderId(node?.data?.metaData?.sender || '', node?.data?.metaData?.senderType || '')

  const templateOptions = useMemo(
    () =>
      templates
        ?.filter((template: TemplateMessage) => template?.type?.toUpperCase() === 'SMS')
        ?.map((template: TemplateMessage) => ({
          value: template?.name,
          label: template?.name,
        })) || [],
    [templates]
  )

  const selectedOption = useMemo(() => {
    if (!selectedTemplate) return null

    const templateName =
      typeof selectedTemplate === 'object' && 'name' in selectedTemplate
        ? selectedTemplate.name
        : selectedTemplate

    return templateOptions.find((tpl) => tpl.value === templateName) || null
  }, [selectedTemplate, templateOptions])

  const confirmationOptions = useMemo(
    () => ({
      closeOnOverlayClick: false,
      labels: {
        confirmable: 'Yes',
        cancellable: 'No',
      },
    }),
    []
  )

  const handleTemplateSelection = useCallback(
    async (event: ReactSelectOption) => {
      const confirmation = await confirm(
        `Are you sure you want to use this ${event?.value} template`,
        confirmationOptions
      )

      if (!confirmation || !event?.value) return

      const template = templates?.find((key: TemplateMessage) => key?.name === event?.value)
      if (template) {
        setIsUpdatingTemplate(true)
        setSelectedTemplate(template)

        setNodes((nds) =>
          nds.map((n) =>
            n.id === node?.id
              ? {
                  ...n,
                  data: {
                    ...n.data,
                    metaData: {
                      ...n.data?.metaData,
                      sms: template,
                    },
                  },
                }
              : n
          )
        )
        setTimeout(() => setIsUpdatingTemplate(false), 100)
      }
    },
    [templates, confirmationOptions, setNodes, node?.id]
  )

  const handleModalSave = useCallback(
    (newTemplate?: TemplateMessage) => {
      setShowTemplateModal(false)
      dispatch(getAllTemplateWithoutPagination())

      if (newTemplate) {
        setIsUpdatingTemplate(true)
        setSelectedTemplate(newTemplate)

        setNodes((nds) =>
          nds.map((n) =>
            n.id === node?.id
              ? {
                  ...n,
                  data: {
                    ...n.data,
                    metaData: {
                      ...n.data?.metaData,
                      sms: newTemplate,
                    },
                  },
                }
              : n
          )
        )
        setTimeout(() => setIsUpdatingTemplate(false), 100)
      }
    },
    [dispatch, setNodes, node?.id]
  )

  const openCreateModal = useCallback(() => {
    setIsEdit(false)
    setShowTemplateModal(true)
  }, [])

  const openEditModal = useCallback(() => {
    setIsEdit(true)
    setShowTemplateModal(true)
  }, [])

  const MenuList = useCallback(
    (props: MenuListProps<any>) => {
      return (
        <components.MenuList {...props}>
          {props.children}
          <div
            style={{
              width: '100%',
              display: 'flex',
              gap: '6px',
              cursor: 'pointer',
              alignItems: 'center',
              justifyContent: 'center',
              borderTop: '1px solid #F4F5F7',
              paddingTop: '10px',
            }}
            onClick={() => {
              openCreateModal()
            }}
          >
            <p
              style={{
                color: '#7950F2',
                margin: 0,
                fontWeight: 600,
              }}
            >
              + Create new
            </p>
          </div>
        </components.MenuList>
      )
    },
    [openCreateModal]
  )

  useEffect(() => {
    if (node.data?.metaData?.sms) {
      setSelectedTemplate(node.data.metaData.sms)
    } else {
      setSelectedTemplate(null)
    }
  }, [node.id, node.data?.metaData?.sms])

  useEffect(() => {
    if (node?.id) {
      const currentSender = node?.data?.metaData?.sender || ''
      const currentSenderType = node?.data?.metaData?.senderType || ''

      if (selectedSender !== currentSender) {
        setSelectedSender(currentSender)
      }

      if (selectedSenderType !== currentSenderType) {
        setSelectedSenderType(currentSenderType)
      }
    }
  }, [
    node?.id,
    node?.data?.metaData?.sender,
    node?.data?.metaData?.senderType,
    selectedSender,
    selectedSenderType,
    setSelectedSender,
    setSelectedSenderType,
  ])

  useEffect(() => {
    // Update sendData when node changes to reflect the current node's data
    setSendData((prev) => ({
      ...prev,
      message: node?.data?.metaData?.sms?.message || '',
      sender: node?.data?.metaData?.sender || 'Sender ID',
      senderType: node?.data?.metaData?.senderType || '',
    }))
  }, [
    node?.id,
    node?.data?.metaData?.sms?.message,
    node?.data?.metaData?.sender,
    node?.data?.metaData?.senderType,
  ])

  // We no longer need this effect as we're handling state updates directly in the onChange handler

  useEffect(() => {
    if (selectedTemplate) {
      setSendData({
        ...sendData,
        message: selectedTemplate?.message || '',
        sender: selectedSender || 'Sender ID',
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedTemplate, selectedSender])

  // Template initialization and fetching
  useEffect(() => {
    dispatch(getAllTemplateWithoutPagination())
  }, [dispatch])

  useEffect(() => {
    const smsFromNode = node?.data?.metaData?.sms || null
    setSelectedTemplate((prev) => {
      if (prev === smsFromNode || (prev && smsFromNode && prev.name === smsFromNode.name)) {
        return prev
      }
      return smsFromNode
    })
  }, [node?.data?.metaData?.sms])

  const MenuListComponent = (props: any) => {
    const {isVisible, ...rest} = props
    return (
      <components.MenuList {...rest}>
        {props.children}
        {rest?.options?.length === 1 && isAdmin === 'false' ? (
          <>
            {isShowCredit && [REGION.AU, REGION.US].includes(userRegion) && (
              <OverlayTrigger
                placement='top'
                overlay={
                  <Tooltip id='button-tooltip'>
                    {t('SENDER_ID.CREATE_NEW_DEDICATED_NUMBER')}
                  </Tooltip>
                }
              >
                <div
                  className={clsx('senderid-menu-action', {'d-none': !isDefaultRegion})}
                  onClick={() => {
                    setVisible(true)
                  }}
                >
                  <i className='bi bi-plus-lg senderid-menu-action__icon'></i>
                  <p className='senderid-menu-action__label'>
                    {t('SENDER_ID.CREATE_NEW_DEDICATED_NUMBER')}
                  </p>
                </div>
              </OverlayTrigger>
            )}
            {isVisible && (
              <>
                {[REGION.AU, REGION.US, REGION.UK].includes(userRegion) && (
                  <OverlayTrigger
                    placement='top'
                    overlay={
                      <Tooltip id='button-tooltip'>
                        {t('SENDER_ID.CREATE_NEW_CUSTOM_BUSINESS_NAME')}
                      </Tooltip>
                    }
                  >
                    <div
                      className={clsx('senderid-menu-action', {
                        'd-none': !isDefaultRegion && ![REGION.UK].includes(userRegion),
                      })}
                      onClick={() => {
                        setName(true)
                      }}
                    >
                      <i className='bi bi-plus-lg senderid-menu-action__icon'></i>
                      <p className='senderid-menu-action__label'>
                        {t('SENDER_ID.CREATE_NEW_CUSTOM_BUSINESS_NAME')}
                      </p>
                    </div>
                  </OverlayTrigger>
                )}
                {[REGION.AU, REGION.US].includes(userRegion) && (
                  <OverlayTrigger
                    placement='top'
                    overlay={
                      <Tooltip id='button-tooltip'>
                        {t('SENDER_ID.CREATE_NEW_CUSTOM_NUMBER')}
                      </Tooltip>
                    }
                  >
                    <div
                      className={clsx('senderid-menu-action', {
                        'd-none': !isDefaultRegion,
                      })}
                      onClick={() => {
                        setCustomNumber(true)
                      }}
                    >
                      <i className='bi bi-plus-lg senderid-menu-action__icon'></i>
                      <p className='senderid-menu-action__label'>
                        {t('SENDER_ID.CREATE_NEW_CUSTOM_NUMBER')}
                      </p>
                    </div>
                  </OverlayTrigger>
                )}
              </>
            )}
          </>
        ) : null}
      </components.MenuList>
    )
  }

  return (
    <div className='w-100 h-100'>
      <div
        style={{
          width: '100%',
          padding: '10px',
        }}
      >
        <StripeJSProvider>
          {({stripe}: any) =>
            stripe ? (
              <Elements stripe={stripe}>
                <VirtualNumbersModal
                  show={visible}
                  handleClose={() => {
                    setVisible(false)
                  }}
                />
              </Elements>
            ) : null
          }
        </StripeJSProvider>
        <CreateBusinessNamePopup show={name} handleClose={() => setName(false)} />
        <CreateCutomNumber show={customNumber} handleClose={() => setCustomNumber(false)} />
        <div className='mb-3' style={{width: '100%'}}>
          <label className='custom-form-label mb-3'>{'From (Sender ID)'}</label>

          <Select
            components={{
              MenuList: (props) => <MenuListComponent isVisible={true} {...props} />,
            }}
            onChange={(e: any) => {
              if (!e?.value) return

              const newSenderValue = e?.value
              const newSenderType = findMatchingArrayName(newSenderValue, senderTypeData)

              setNodes((nds) =>
                nds.map((n) =>
                  n.id === node.id
                    ? {
                        ...n,
                        data: {
                          ...n.data,
                          metaData: {
                            ...n.data?.metaData,
                            sender: newSenderValue,
                            senderType: newSenderType,
                          },
                        },
                      }
                    : n
                )
              )
              setSelectedSender(newSenderValue)
              setSelectedSenderType(newSenderType)

              // Handle optout settings
              if (alphaID.includes(newSenderType)) {
                const DefaultOptout = optoutList?.find(
                  (key: any) => key?._id === OptOutDefault?.defaultOptoutId
                )
                let tempOptout: any = {optout: false, optoutId: ''}
                if (DefaultOptout?.title) {
                  tempOptout = {
                    ...tempOptout,
                    optout: true,
                    optoutId: DefaultOptout?._id,
                    optoutLabel: DefaultOptout?.title,
                  }
                } else if (optoutList?.length > 0) {
                  tempOptout = {
                    ...tempOptout,
                    optout: true,
                    optoutId: optoutList?.[0]?._id,
                    optoutLabel: optoutList?.[0]?.title,
                  }
                }

                setSendData({
                  ...sendData,
                  sender: newSenderValue,
                  senderType: newSenderType,
                  replyStopToOptOut: false,
                  ...tempOptout,
                })
              } else {
                let replyStopToOptOut = !!sendData?.optoutId ? sendData?.replyStopToOptOut : true

                if (!optoutList?.length) {
                  replyStopToOptOut = false
                }

                setSendData({
                  ...sendData,
                  replyStopToOptOut,
                  sender: newSenderValue,
                  senderType: newSenderType,
                })
              }
            }}
            value={
              selectedSender
                ? {value: selectedSender, label: selectedSender}
                : {
                    value: [REGION.AU, REGION.US].includes(userRegion) ? '#SharedNum#' : '',
                    label: [REGION.AU, REGION.US].includes(userRegion)
                      ? '#SharedNum#'
                      : 'Select Sender',
                  }
            }
            options={[
              ...([REGION.AU, REGION.US].includes(userRegion)
                ? [{value: '#SharedNum#', label: '#SharedNum#'}]
                : []),
              ...([REGION.AU, REGION.US].includes(userRegion) ? dedicatedOptionSMS : []),
              ...([REGION.AU, REGION.US].includes(userRegion) ? dedicatedOptionMMS : []),
              ...([REGION.AU, REGION.US, REGION.UK].includes(userRegion) ? businessNameOption : []),
              ...([REGION.AU, REGION.US].includes(userRegion) ? customNumberOption : []),
            ]}
            data-testid='ddSenderID'
            isOptionDisabled={(option: any, value: any) =>
              option?.disabled ? option?.disabled : false
            }
          />
        </div>
      </div>

      <div className='mb-3' style={{width: '100%'}}>
        <div className='d-flex align-items-center justify-content-between mb-3'>
          <label className='custom-form-label mb-0'>{t('FLOW.TEMPLATE_SELECTION')}</label>
          {selectedTemplate && (
            <i
              className='bi bi-pencil'
              title={t('FLOW.EDIT_TEMPLATE')}
              onClick={openEditModal}
              style={{cursor: 'pointer'}}
            />
          )}
        </div>

        <div className='d-flex align-items-center' style={{gap: 8, padding: 5}}>
          <Select
            isSearchable={true}
            value={selectedOption}
            onChange={(newValue) => {
              if (newValue) {
                handleTemplateSelection(newValue)
              }
            }}
            options={templateOptions}
            name='message'
            className='common-select z-1000 w-100'
            placeholder={t('FLOW.SELECT_TEMPLATE')}
            classNamePrefix='nodrag'
            menuPortalTarget={typeof window !== 'undefined' ? document.body : undefined}
            closeMenuOnScroll={true}
            menuShouldBlockScroll={false}
            styles={{
              control: (base) => ({
                ...base,
                backgroundColor: 'var(--bs-gray-200) !important',
                borderColor: base.borderColor,
                boxShadow: base.boxShadow,
              }),
            }}
            onMenuOpen={() => setIsSelectOpen(true)}
            onMenuClose={() => setIsSelectOpen(false)}
            openMenuOnFocus={true}
            components={{
              MenuList: (props) => <MenuList {...props} />,
            }}
          />
        </div>
      </div>

      <div className='w-100 h-100 col-12 col-md-6 col-lg-4 NewQuickMsgPreview'>
        <div className='new_newmessage_right new_newmessage_right_mobile'>
          <h5
            style={{
              marginBottom: '16px',
            }}
          >
            Preview
          </h5>
          <nav>
            <div
              className='nav nav-tabs'
              id='nav-tab'
              role='tablist'
              data-testid='previewMessageOption'
            >
              <button
                className='nav-link active rounded-end-0'
                id='nav-preview-on-unlocked'
                data-bs-toggle='tab'
                data-bs-target='#nav-preview-on-unlocked-screen'
                type='button'
                role='tab'
                aria-controls='nav-preview-on-unlocked-screen'
                aria-selected='true'
              >
                <KTSVG path='/media/icons/duotune/locked/unlocked.svg' />
                <span className='text'>In Message</span>
              </button>
              <button
                className='nav-link rounded-start-0'
                id='nav-preview-on-locked'
                data-bs-toggle='tab'
                data-bs-target='#nav-preview-on-locked-screen'
                type='button'
                role='tab'
                aria-controls='nav-preview-on-locked-screen'
                aria-selected='false'
              >
                <KTSVG path='/media/icons/duotune/locked/locked.svg' />
                <span className='text'>Lockscreen</span>
              </button>
            </div>
          </nav>
          <div className='tab-content' id='nav-tabContent'>
            <div
              className='active fade show tab-pane'
              id='nav-preview-on-unlocked-screen'
              role='tabpanel'
              aria-labelledby='nav-preview-on-unlocked-screen'
            >
              <div
                className='active fade show tab-pane'
                id='nav-preview-on-unlocked-screen'
                role='tabpanel'
                aria-labelledby='nav-preview-on-unlocked-screen'
              >
                <div
                  className='grey-bg mobile-bg-wrapper new_mobile'
                  style={{
                    backgroundImage: `url(${toAbsoluteUrl('/media/mobile/NewMobile.png')})`,
                  }}
                >
                  <div className='mobile-inner'>
                    <div className='mobile-head'>
                      <strong
                        className='d-block p-6 text-center msg-mobile-title px-12'
                        data-testid='txtPreviewSenderID'
                      >
                        <KTSVG
                          className='svg-icon-8'
                          path='/media/icons/duotune/arrows/mobile_left_arrow.svg'
                        />{' '}
                        {node?.data?.metaData?.sender || 'Sender ID'}
                      </strong>
                    </div>
                    <div className='mobile-body'>
                      <div className='message-box' data-testid='previewMessageBox'>
                        <div className='text-center time'>Today {moment().format('LT')}</div>

                        <div className='message'>
                          <pre>{`${
                            removeOptOutOrReply(sendData?.message) ||
                            `1. 'Insert field' to add client name
2. Smartlink to track clicks
3. Sign-off with your name & contact
4. 'stoptxt' opt-out survey
`
                          }`}</pre>
                        </div>
                      </div>
                      <div className='send-msg'>
                        <input type='text' />
                        <a
                          href='#'
                          className='send_btn'
                          style={{
                            backgroundImage: `url(${toAbsoluteUrl('/media/mobile/send.svg')})`,
                          }}
                        ></a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className='fade tab-pane'
              id='nav-preview-on-locked-screen'
              role='tabpanel'
              aria-labelledby='nav-preview-on-locked-screen'
            >
              <div
                className='grey-bg mobile-bg-wrapper new_mobile'
                style={{
                  backgroundImage: `url(${toAbsoluteUrl('/media/mobile/unlock-screen.svg')})`,
                }}
              >
                <div className='unlock-screen-content'>
                  <div className='notification-outer'>
                    <div className='Notification-item'>
                      <div className='user-icon'>
                        <img
                          alt='Logo'
                          src={toAbsoluteUrl('/media/mobile/user-icon-notification.png')}
                        />
                      </div>
                      <div
                        className='notification-data'
                        style={{
                          width: '100%',
                        }}
                      >
                        <label htmlFor='' data-testid='txtPreviewSenderID'>
                          &#x2329;{' '}
                          {sendData?.sender === '#SharedNum#'
                            ? '#SharedNum#'
                            : sendData?.sender || 'Sender ID'}
                          &#12297;
                        </label>
                        <div className='nofication-detail-box' data-testid='notifMessageBox'>
                          <p>{sendData?.message || 'Engaging message here'}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Template Creation/Editing Modal */}
      <Modal
        show={showTemplateModal}
        onHide={() => setShowTemplateModal(false)}
        size='xl'
        centered
        keyboard={true}
      >
        <Modal.Body>
          <div
            className='sms-node-modal-body'
            onClick={(e) => e.stopPropagation()}
            onMouseDown={(e) => e.stopPropagation()}
          >
            <CreateScratchV2
              onSave={handleModalSave}
              shouldDirectAfterSave={false}
              isEdit={isEdit}
              id={isEdit ? selectedTemplate?._id : undefined}
              templateData={isEdit ? selectedTemplate : undefined}
            />
          </div>
        </Modal.Body>
      </Modal>
    </div>
  )
}

export default SMSSidebar
